import { useCreateUsageCompilationMutation, useEditUsageCompilationMutation } from "../../../api/usageCompilationApi";

/**
 * Data/API Layer - mirrors _features/usageSources/modals/
 * UsageSourceFormModal/hooks/useUsageSourceFormMutations.js. Create/edit
 * only - the checkUsageSource mutation lives in useUsageCompilationCascade.js
 * instead, since it's a distinct concern (populating dynamic field
 * options, not part of the create/edit write path).
 */
export function useUsageCompilationFormMutations() {
  const [createUsageCompilation, { isLoading: isCreating }] = useCreateUsageCompilationMutation();
  const [updateUsageCompilation, { isLoading: isUpdating }] = useEditUsageCompilationMutation();

  async function submitUsageCompilation({ mode, validData, rowData }) {
    if (mode === "create") {
      return await createUsageCompilation(validData).unwrap();
    }

    return await updateUsageCompilation({ ...validData, _id: rowData?._id }).unwrap();
  }

  return {
    submitUsageCompilation,
    isSubmitting: isCreating || isUpdating,
  };
}
